'use strict';

import { baseInit, baseInitGpt, baseSetupHeroSkin } from './_base';
import fullScreenGallery from '../components/full-screen-gallery';
import previewSlider from '../components/preview-slider';
import footerNav from '../components/review/footer-nav';
import videoPlayer from '../components/video-player';
import affiliateLinks from '../utils/affiliate-links';

export function init() {
	baseInit();
	fullScreenGallery.init();
	previewSlider.init();
	footerNav.init();
	videoPlayer.init();
	affiliateLinks.init();
}

export function initGpt(adConfig) {
	baseInitGpt(adConfig);
}

export function setupHeroSkin(options) {
	baseSetupHeroSkin(options);
}